import { render, staticRenderFns } from "./NewRegister.vue?vue&type=template&id=4531f02b&scoped=true&"
import script from "./NewRegister.vue?vue&type=script&lang=js&"
export * from "./NewRegister.vue?vue&type=script&lang=js&"
import style0 from "./NewRegister.vue?vue&type=style&index=0&id=4531f02b&lang=scss&scoped=true&"
import style1 from "./NewRegister.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4531f02b",
  null
  
)

export default component.exports